<template>
<div class="iccidPriceSwitchOrderList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">VIP智能切网订单列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="ICCID:">
                <el-input v-model="form.iccid" placeholder="请输入短号或ICCID"></el-input>
            </el-form-item>
            <el-form-item label="订单号:">
                <el-input v-model="form.orderNumber" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="订单状态:">
                <el-select v-model="form.status" placeholder="请选择订单状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="已退款" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="支付方法:">
                <el-select v-model="form.payMethod" placeholder="请选择支付方法">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="微信" value="1"></el-option>
                    <el-option label="余额" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-back" class="themed-button" @click="goBack">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="订单号" prop="orderNumber" show-overflow-tooltip></el-table-column>
            
            <el-table-column label="开始时间" prop="effectStartTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.effectStartTime) }}
                </template>
            </el-table-column>
            <el-table-column label="结束时间" prop="effectEndTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.effectEndTime) }}
                </template>
            </el-table-column>
            
            <el-table-column label="订单状态" prop="status" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatOrderStatus(scope.row.status) }}
                </template>
            </el-table-column>
            <el-table-column label="订单金额" prop="amount" show-overflow-tooltip>
                <template slot-scope="scope">
                    ¥{{ scope.row.amount }}
                </template>
            </el-table-column>
            <el-table-column label="退款金额" prop="refundAmount" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.refundAmount ? '¥' + scope.row.refundAmount : '-' }}
                </template>
            </el-table-column>
            <el-table-column label="支付方法" prop="payMethod" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatPayMethod(scope.row.payMethod) }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="支付时间" prop="payTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.payTime) }}
                </template>
            </el-table-column>
            <el-table-column label="退款时间" prop="refundTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.refundTime) }}
                </template>
            </el-table-column>
            <el-table-column label="退款原因" prop="refundReason" show-overflow-tooltip></el-table-column>
            <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                    <el-button 
                        v-if="scope.row.status == 1" 
                        type="warning" 
                        size="mini" 
                        class="themed-button" 
                        @click="handleRefund(scope.row)">
                        退款
                    </el-button>
                    <span v-else>-</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 退款弹框 -->
    <el-dialog title="订单退款" :visible.sync="refundDialogVisible" width="500px">
        <el-form :model="refundForm" label-width="100px" :rules="refundRules" ref="refundForm">
            <el-form-item label="订单号:">
                <el-input v-model="refundForm.orderNumber" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单金额:">
                <el-input v-model="refundForm.orderAmount" disabled>
                    <template slot="prepend">¥</template>
                </el-input>
            </el-form-item>
            <el-form-item label="退款金额:" prop="refundMoney" required>
                <el-input v-model="refundForm.refundMoney" placeholder="请输入退款金额" type="number">
                    <template slot="prepend">¥</template>
                </el-input>
                <div style="color:#999; font-size:12px; margin-top:5px;">退款金额需要小于等于订单金额</div>
            </el-form-item>
            <el-form-item label="退款原因:" prop="remark">
                <el-input v-model="refundForm.remark" type="textarea" rows="3" placeholder="请输入退款原因"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="primary" @click="submitRefund">确 定</el-button>
            <el-button class="themed-button" type="primary" @click="refundDialogVisible = false">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    orderList,
    refundVipSwitchOrder
} from '@/api/iccidPriceSwitch/list.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'

export default {
    name: 'iccidPriceSwitchOrderList',
    mixins: [resize],
    data() {
        return {
            form: {
                iccid: '',
                orderNumber: '',
                status: '',
                payMethod: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 退款弹框数据
            refundDialogVisible: false,
            refundForm: {
                orderId: '',
                orderNumber: '',
                orderAmount: '',
                refundMoney: '',
                remark: ''
            },
            refundRules: {
                refundMoney: [
                    { required: true, message: '请输入退款金额', trigger: 'blur' },
                    { validator: this.validateRefundMoney, trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: '请输入退款原因', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        // 从路由参数中获取iccid
        if (this.$route.query.iccid) {
            this.form.iccid = this.$route.query.iccid
        }
        this.getList()
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            orderList(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 返回上一页
        goBack() {
            this.$router.go(-1)
        },

        // 退款操作
        handleRefund(row) {
            this.refundForm = {
                orderId: row.id,
                orderNumber: row.orderNumber,
                orderAmount: row.amount,
                refundMoney: '',
                remark: ''
            }
            this.refundDialogVisible = true
        },

        // 提交退款
        submitRefund() {
            this.$refs.refundForm.validate((valid) => {
                if (valid) {
                    confirmBox(this, `确定要退款 ¥${this.refundForm.refundMoney} 吗？`, '退款确认', () => {
                        const params = {
                            orderId: this.refundForm.orderId,
                            refundMoney: this.refundForm.refundMoney,
                            remark: this.refundForm.remark
                        }
                        
                        refundVipSwitchOrder(params).then(res => {
                            if (res.system_result_key === '0') {
                                this.$message.success(res.system_result_message_key || '退款成功')
                                this.refundDialogVisible = false
                                this.getList()
                            } else {
                                this.$message.error(res.system_result_message_key || '退款失败')
                            }
                        }).catch(err => {
                            this.$message.error('退款失败，请稍后重试')
                            console.error(err)
                        })
                    })
                }
            })
        },

        // 验证退款金额
        validateRefundMoney(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入退款金额'))
            } else if (isNaN(value) || value <= 0) {
                callback(new Error('退款金额必须大于0'))
            } else if (parseFloat(value) > parseFloat(this.refundForm.orderAmount)) {
                callback(new Error('退款金额不能大于订单金额'))
            } else {
                callback()
            }
        },

        // 格式化订单状态
        formatOrderStatus(status) {
            const statusMap = {
                '0': '待支付',
                '1': '已支付',
                '2': '已退款'
            };
            return statusMap[status] || '-';
        },

        // 格式化支付方法
        formatPayMethod(payMethod) {
            const methodMap = {
                '1': '微信',
                '2': '余额'
            };
            return methodMap[payMethod] || '-';
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        }
    }
}
</script>

<style scoped>
.iccidPriceSwitchOrderList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}
</style> 